<template>
  <div>
    <el-form ref="searchForm" :inline="true" class="searchBoxLine" :model="searchForm">
      <el-form-item label="实际付款人名称:" prop="drawee">
        <el-input v-model="searchForm.drawee" placeholder="请输入实际付款人名称" />
      </el-form-item>
      <el-form-item label="汇入公司:" prop="importCompany">
        <el-input v-model="searchForm.importCompany" placeholder="请输入汇入公司" />
      </el-form-item>
      <el-form-item label="汇入银行:" prop="importBank">
        <el-input v-model="searchForm.importBank" placeholder="请输入汇入银行" />
      </el-form-item>
      <el-form-item label="付款用途:" prop="remittanceScenario">
        <!-- <el-input v-model="searchForm.remittanceScenario" placeholder="请输入付款用途" /> -->
        <el-select v-model="searchForm.remittanceScenario" placeholder="请选择" clearable>
          <el-option v-for="(item,val) of remittanceScenarioOptionsCN" :key="val" :value="val" :label="item" />
        </el-select>
      </el-form-item>
      <el-form-item label="付款日期:" prop="createBeginTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.remittanceStartTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.remittanceEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :picker-options="pickerOptions"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item label="客户名称:" prop="userName">
        <el-input v-model="searchForm.userName" placeholder="请输入客户名称" />
      </el-form-item>
      <el-form-item label="付款方式:" prop="remittanceWay">
        <!-- <el-input v-model="searchForm.remittanceWay" placeholder="请输入付款方式" /> -->
        <el-select v-model="searchForm.remittanceWay" placeholder="请选择" clearable>
          <el-option v-for="(item,val) of remittanceWayOptions" :key="val" :value="val" :label="item" />
        </el-select>
      </el-form-item>
      <el-form-item label="状态:" prop="remittanceState">
        <el-select v-model="searchForm.remittanceState" placeholder="请选择" clearable>
          <el-option v-for="item in remittanceStateOptions" :key="item.value" :value="item.value" :label="item.label" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :loading="Loading" @click="doSearch">
          搜索
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
      </el-form-item>
    </el-form>
    <div v-loading="tableLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="telegraphicTransferNo" label="汇款编号" align="left" fixed="left">
          <template v-slot="{row}">
            <el-button type="text" @click="showDetail(row)">
              {{ row.telegraphicTransferNo }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="importCompany" label="汇入公司" align="left" />
        <el-table-column prop="importBank" label="汇入银行" align="left" />
        <el-table-column prop="remittanceAmount" label="付款金额" align="right" header-align="left" />
        <el-table-column prop="currencyName" label="币种" align="left" />
        <el-table-column prop="sourceCompany" label="客户名称" align="left" />
        <el-table-column prop="paymentAccount" label="实际付款人名称" align="left" />
        <el-table-column prop="remittanceTime" label="付款日期" align="left" />
        <el-table-column prop="actualRemittanceAmount" label="实际到账金额" align="right" header-align="left" />
        <el-table-column prop="serviceFee" label="手续费" align="right" header-align="left" />
        <el-table-column prop="strRemittanceScenario" label="付款用途" align="left" />
        <el-table-column prop="strRemittanceType" label="付款类型" align="left" />
        <el-table-column prop="strRemittanceWay" label="付款方式" align="left" />
        <el-table-column prop="strRemittanceState" label="状态" align="left" />
        <el-table-column prop="isReceipt" label="已生成收款单" align="left">
          <template v-slot="{row}">
            <span v-if="row.isReceipt">是</span>
            <span v-else>否</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.currentPage"
          layout="total, prev, pager, next, jumper,sizes"
          :total="page.total"
          hide-on-single-page
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="电汇底单详细信息" :visible.sync="businessListVisible" width="800px">
      <businessListDetail v-if="businessListVisible" :id="telegraphicTransferNumID" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="businessListVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="es6">
import { mapState } from 'vuex';
import businessListDetail from './components/businessListDetail.vue';
import { listTelegraphicTransferInternation } from '@/API/international.js';
export default {
  data () {
    return {
      searchForm: {
        drawee: '',
        importCompany: '',
        remittanceStartTime: '',
        remittanceEndTime: '',
        remittanceScenario: '',
        remittanceWay: '',
        importBank: '',
        userName: '',
        remittanceState: ''
      },
      businessListVisible: false, // 查看信息详情
      remittanceStateOptions: [
        {
          value: '',
          label: '全部'
        }, {
          value: '1',
          label: '待确认到账'
        }, {
          value: '2',
          label: '待核查户到账'
        }, {
          value: '3',
          label: '一般户到账'
        }, {
          value: '4',
          label: '未收到LC'
        }, {
          value: '5',
          label: '收到LC正本'
        }, {
          value: '6',
          label: '确认到账'
        }],
      Loading: false,
      tableData: [],
      tableLoading: false,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      pickerOptions: {
        disabledDate: (time) => {
          if (this.searchForm.remittanceStartTime) {
            let date = new Date(this.searchForm.remittanceStartTime);
            date.setDate(date.getDate() - 1);
            return time.getTime() <= date.getTime();
          }
          return false;
        }
      }
    };
  },
  components: {
    businessListDetail
  },
  computed: {
    ...mapState({
      businessNameList: state => state.enumeration.businessNameList, //  业务实体列表-来款记录查询(财务)
      importCompanyList: state => state.enumeration.importCompanyList, //  银行账号信息列表-来款记录查询(财务)
      getBankInfoList: state => state.enumeration.getBankInfoList, // 根据供货单位ID获取银行列表
      remittanceScenarioOptions: state => state.enumeration.remittanceScenarioOptions,
      remittanceWayOptions: state => state.enumeration.remittanceWay,
      remittanceScenarioOptionsCN: state => state.enumeration.remittanceScenarioOptionsCN
    })
  },
  methods: {
    doSearch () {
      this.tableLoading = true;
      listTelegraphicTransferInternation({
        ...this.searchForm,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.tableLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.tableData = json.data.list;
          this.page.total = json.data.total;
          this.$emit('totalNumber', this.page.total);
        }
      }).catch(() => {
        this.tableLoading = false;
      });
    },
    doSearches (data, cab) {
      this.page.currentPage = 1;
      this.doSearch();
      cab(false);
    },
    handerSizeChange (val) {
      // 改变每页条数 当前页回到第一页
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      // 改变当前页
      this.doSearch();
    },
    showFile (row) {
      this.$refs.fileDialog.showFile(row.id);
    },
    godoIt (row) {
      this.$router.push({
        'name': 'businessHandler',
        params: {
          contractNum: row.contractNum,
          contractType: row.contractType
        }
      });
    },
    showDetail (row) {
      this.telegraphicTransferNumID = row.id;
      this.businessListVisible = true;
    },
    tableRowClassName ({ row }) {
      // if (row.salesType === 2) {
      //   return 'warning-row';
      // }
      // if (row.isHuaQiangFlag === 1) {
      //   return 'highlight-row';
      // }
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.searchForm.createEndTime = '';
      this.searchForm.startDistributionRatio = '';
      this.doSearch();
    }
  },
  mounted () {
    this.doSearch();
    this.$store.dispatch('enumeration/initremittance');
  }
};
</script>
<style>
  .el-table .warning-row {
    color: red;
  }
  .el-table .highlight-row {
    color: #67C23A;
  }
</style>
